import './assets/main.css'

if (import.meta.env.VITE_MY_WEALTH_MODE === 'true') {
    import ('./assets/MWP.css')
} else {
    import ('./assets/MWI.css')
}

import { createApp, provide, h } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { POOL_DATA } from "./config/cognito";
import { Amplify } from 'aws-amplify';

import App from './App.vue'
import router from './router'
import store from "./store";
import BaseSpinner from "./components/ui/BaseSpinner.vue";
import BaseMessage from "./components/ui/BaseMessage.vue";
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';

import axios from "axios";
import VueAxios from "vue-axios";

import * as Sentry from "@sentry/vue";

import { provideApolloClient } from "@vue/apollo-composable";

import { apolloClient } from "./utils/apolloClient";

import '@fortawesome/fontawesome-free/css/all.min.css';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
pinia.use(Sentry.createSentryPiniaPlugin())

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolClientId: POOL_DATA.ClientId,
            userPoolId: POOL_DATA.UserPoolId,
        }
    }
});

const app = createApp({
    setup () {
        provideApolloClient(apolloClient);
    },
    render: () => h(App),
})

// Only initialise Sentry in non-dev environments
if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    app,
    dsn: "https://900e372dc31d800ffbe9171f90350cb1@o4507272052539392.ingest.de.sentry.io/4507894586277968",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 0.1, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

app
    .use(store)
    .use(pinia)
    .use(router)
    .use(Donut)
    .use(VueAxios, axios)
    .component("base-spinner", BaseSpinner)
    .component("base-message", BaseMessage)
    .mount("#app");
